<template>
  <div class="father">
    <div v-html="innerHtml"></div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="资源下载" name="first">
        <div class="item-body">
          <div
            class="item"
            :style="`background: linear-gradient(145deg,${Color()},transparent);`"
            v-for="(item, index) in downList"
            :key="index"
          >
            <!-- <div class="left">1</div> -->
            <div class="right">
              <h3 style="margin: 0; color: #000">{{ item.label }}</h3>
              <h5
                style="
                  margin: 10px 0;
                  border-bottom: 1px solid #ccc;
                  height: 50px;
                  color: #595959;
                "
              >
                {{ item.desc }}
              </h5>
              <div class="right-bottom">
                <span class="free"> 免费</span>
                <a
                  v-if="typeof item.url == 'string'"
                  :href="item.url"
                  class="item-a"
                  >点击下载</a
                >
                <div v-else>
                  <div v-for="(items, i) in item.url" :key="i">
                    <a :href="items.url" class="item-a"
                      >下载&nbsp;{{ items.version }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getAssets } from "@/api/index.js";
import { Avatar } from "element-ui";
// import { baseUrl } from "@/api/common.js";
const baseUrl = "https://pan.hakspay.cn/SOFTWARE/";
export default {
  data() {
    return {
      activeName: "first", //选中的tab
      innerHtml: "",
      downList: [
        {
          label: "eServer 服务中间件",
          desc: "巨龙云库 服务，小程序服务后台程序免费提供电子会员、建档、调价、报表查询等功能",
          baseurl: `${baseUrl}eServer/`,
          url: [],
        },
        {
          label: "eServerEx 扩展服务",
          desc: "多易禾扩展服务，提供线上打印功能。",
          baseurl: `${baseUrl}eServerEx/`,
          url: [],
        },
        /* {
          label: "eServer 升级包",
          desc: "巨龙云库 升级包，可将旧版云库升级",
          url: `${baseUrl}/media/upgrade/eServer.exe`
        }, */
        // {
        //   label: "serverEx 客户端",
        //   desc: "标签打印扩展服务，提供新北洋、tsc 等打印机手机打印服务",
        //   url: `${baseUrl}/media/upgrade/serverEx.exe`
        // },
        /* {
          label: "蓝色标价签",
          desc: "经典的蓝色标签模板",
          url: `${baseUrl}/media/label/blue20240325.json`
        }, */

        {
          label: "支付服务（ePay）",
          desc: "多易禾支付服务，提供微信、支付宝等收款功能。",
          baseurl: `${baseUrl}ePay/`,
          url: [],
        },
        {
          label: "PDA服务（盘点机服务）",
          desc: "多易禾盘点机服务，需要配合专用盘点机使用，提供pda需要的数据接口。",
          baseurl: `${baseUrl}pda/`,
          url: [],
        },
        {
          label: "屏幕服务",
          desc: "多易禾电子屏服务，提供电子屏幕的接口。",
          baseurl: `${baseUrl}sreen/`,
          url: [],
        },
        {
          label: ".NET 4.8",
          desc: "最新服务的运行环境",
          url: [
            {
              url: `${baseUrl}/windows/NDP48-x86-x64-AllOS-ENU.exe`,
              version: "NET 4.8",
            },
            {
              url: `${baseUrl}/windows/Windows2008补丁安装NET4.8.msu`,
              version: "NET 4.8.msu",
            },
          ],
        },
        {
          label: ".NET 4.5",
          desc: "Windows 的托管执行环境，可为其运行的应用提供各种服务",
          url: "https://download.microsoft.com/download/B/A/4/BA4A7E71-2906-4B2D-A0E1-80CF16844F5F/dotNetFx45_Full_setup.exe",
        },
        {
          label: "向日葵远程",
          desc: "向日葵远程控制软件",
          url: `${baseUrl}/tools/SunloginClient_15.8.2.19742_x64.exe`,
        },
      ],
      html: "",
    };
  },
  mounted() {
    // this.ccccc();
    // this.eServer();
    this.getServiceUrl();
  },
  methods: {
    getRandom(min, max) {
      const floatRandom = Math.random();

      const difference = max - min;

      // 介于 0 和差值之间的随机数
      const random = Math.round(difference * floatRandom);

      const randomWithinRange = random + min;

      return randomWithinRange;
    },
    Color() {
      this.r = Math.floor(this.getRandom(150,255));
      this.g = Math.floor(this.getRandom(150,255));
      this.b = Math.floor(this.getRandom(150,255));
      return "rgba(" + this.r + "," + this.g + "," + this.b + ",0.3)";
    },
    async ccccc() {
      const aaa = await getAssets("https://pan.hakspay.cn/SOFTWARE/");
      // this.innerHtml = aaa.data;

      const parser = new DOMParser();

      const xmlString = aaa.data;
      const doc = parser.parseFromString(xmlString, "application/html");
      const children = doc.documentElement.children;

      /* this.html = result.data;
      setTimeout(() => {
        const a = document.querySelectorAll("a");
        console.log(a);
      }, 100); */
    },
    getServiceUrl() {
      const that = this;
      this.downList.forEach((item, index) => {
        if (item.baseurl) {
          that.eServer(item.baseurl, index);
        }
      });
    },
    /**
     * 获取eServer
     */
    /**
     *
     * @param {string} url 需要请求的线上地址
     * @param {string} index 在数组中的第几列
     */
    async eServer(url, index) {
      // const url = "https://pan.hakspay.cn/SOFTWARE/eServer/";
      const aaa = await getAssets(url);
      const list = this.myParse(aaa.data);
      let arr = [];
      for (let i = 0; i < list.length; i++) {
        if (
          list[i] &&
          list[i] != undefined &&
          list[i] != "undefined" &&
          list[i].length
        ) {
          // console.log(list[i].split("V")[1]);
          arr.push({
            url: `${url}${list[i]}`,
            version: list[i].split("V")[1].replace(".exe", ""),
          });
        }
      }
      this.downList[index].url = arr;
    },
    /**
     * 正则表达式
     * @param {string} html
     * @returns {string[]} 返回a标签的
     */
    myParse(html) {
      const reg = /<A HREF="([^"]+)">/gi; // 添加i标志使匹配不区分大小写
      const list = [];
      let match;
      // 使用exec方法的返回值来获取匹配结果
      while ((match = reg.exec(html)) !== null) {
        // match[0]是完整匹配，match[1]是第一个捕获组
        list.push(decodeURI(match[1].split("/")[3]));
      }
      return list;
    },
  },
};
</script>
<style lang="less" scoped>
.father {
  padding: 20px;
  display: flex;
  flex-direction: column;
  .item-body {
    display: flex;
    justify-content: left;

    flex-wrap: wrap;
    .item {
      margin: 10px;
      height: auto;
      width: 30% !important;
      min-width: 30%;
      max-width: 30%;
      // background-color:;
      border-radius: 10px;
      padding: 10px;
      flex: 1;
      display: flex;
      // box-shadow: 0 0 10px rgb(198, 198, 198);
      border: 1px solid rgb(222, 222, 222);
      // background-color: rgb(206, 87, 87);
      .item-a {
        text-decoration: none !important;
        color: #409eff;
      }
      .item-a:hover {
        // color: rgb(16, 0, 135);

        border-bottom: 2px solid #409eff;
      }
    }
    .free {
      width: auto;
      border-radius: 5px;
      background-color: #e1f3d8;
      padding: 5px 10px;
      border: 1px solid #67c23a;
      color: #67c23a;
    }
    .item:hover {
      // color: rgb(16, 0, 135);
      // border-bottom: 2px solid #409eff;
      cursor: pointer;
      box-shadow: 0 0 10px rgb(198, 198, 198);
    }
    /* .left {
      width: 40%;
      height: 100%;
      margin-right: 10px;
      background-color: #67c23a;
      border-radius: 10px;
    } */
    .right {
      width: 100%;
      height: 100%;
      // background-color: red;
      .right-bottom {
        height: calc(100% - 100px) !important;
        padding-right: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
}
</style>
